export enum FuelConsumptionMeasurement {
    MilesPerGallon,
    UnitedStatesMilesPerGallon,
    KilometresPerLitre,
    LitresPer100Kilometres
}
